<div *ngIf="(loader.isLoading$ | async)" class="spinner-overlay">
  <span class="loader"></span>
</div>
